var render = function render(){var _vm=this,_c=_vm._self._c;return _c('i',{staticClass:"binds-svg-loader",domProps:{"innerHTML":_vm._s(_vm.html)}})
}
var staticRenderFns = []

export { render, staticRenderFns }